import React, { useState } from "react";

import FormField from "../../../FormField";

const AssetName = () => {
  const [name, setName] = useState();

  const handleName = (e) => {
    setName(e.target.value);
  };

  return (
    <FormField label="Asset Name">
      <input
        type="text"
        placeholder="Enter Asset Name"
        value={name}
        onChange={handleName}
      />
    </FormField>
  );
};

export default AssetName;
